import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Chat, Transaction } from "./dashboard.model";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { takeUntil } from "rxjs/operators";
import { DataService } from "src/app/shared/Services/data.service";
import { HttpClient } from "@angular/common/http";
import { Subject, Subscription } from "rxjs";
import { ShareService } from "src/app/shared/Services/shared.service";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";

export interface ChartType {
  series?: any;
  plotOptions?: any;
  stroke?: any;
  dataLabels?: any;
  chart?: any;
  legend?: any;
  colors?: any;
  labels?: any;
}

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  private cancelPreviousRequests$ = new Subject<void>();
  subscriptions: Subscription[] = [];
  showload: boolean = false;
  sparklineEarning: any = {};
  term: any;
  chatData: Chat[];
  transactions: Transaction[];
  custId:any;
  apiInterval: any;
  enable: boolean = false;
  cancelRequest: boolean = false;
  timeZone: any;
  role: any;
  departmentData: any = [];
  selectedDepartment = "";
  liveBool: boolean = false;
  time: any = [];
  todayData: any = [];
  yesterdayData: any = [];
  queryDate: any;
  chartData: any;
  todayKey: any;
  yesterdayKey: any;
  todaySummary: any;
  user: any;
  email: any;
  shiftName: any;
  currentShiftData: any;
  current: any;
  avail: any;
  m_effic: any;
  perf: any;
  quality: any;
  parts: any;
  prodLoss: any;
  energycost: any;
  machine_List: any = [];
  breadCrumbItems: Array<{}>;
  chatSubmit: boolean;
  formData: FormGroup;
  showGraph: boolean = false;
  lut: any;
  deviceList: any = [];
  performanceOption: any;
  oeeOption: any;

  constructor(
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private http: HttpClient,
    private router: Router,
    private sharedService: ShareService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private currentshifts: GetCurrentShift
  ) {
    this.user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.role = this.user["user"]["role"];
    this.custId = this.user["user"]["custId"];
    this.email = this.user["user"]["email"];
    this.shiftName = this.user["user"]["currentShift"]["shiftName"];
  }

  ngOnInit(): void {
    this.showload = true;
    this.spinner.show();
    this.user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custId = this.user["user"]["custId"];
    this.timeZone = this.user["user"]["timeZone"];
    this.breadCrumbItems = [
      { label: "K2" },
      { label: "Dashboard", active: true },
    ];
    this.formData = this.formBuilder.group({
      message: ["", [Validators.required]],
    });
    this.getDepartment();
    this.auditLogs(); 
  }

  auditLogs() {
    let obj = {
      custID: this.custId,
    };
    const subscription = this.dataservice
      .reportApi(
        "auditlog/department",
        obj
      )
      .subscribe(
        (res) => {},
        (error) => {
          this.toastr.error("Server Unreachable", error);
        }
      );
    this.subscriptions.push(subscription);
  }

  getDepartment() {
    this.departmentData = [];
    this.dataservice.get(`department`).subscribe((res: any) => {
      if (res) {
        if (this.role == "SUPERVISOR") {
          let filteredDepartments = res["data"].filter((department) =>
            department.mappedData.some(
              (mapped) =>
                mapped.supervisor === this.email &&
                mapped.shiftName === this.shiftName
            )
          );
          this.departmentData = filteredDepartments;
          if (this.departmentData.length) {
            var shift: any = {
              shift: this.departmentData[0]["shiftData"],
            };
            sessionStorage.setItem("shiftInfio", JSON.stringify(shift));
            this.currentShiftData = this.currentshifts.getCurrentShift(
              this.departmentData[0]["shiftData"],
              this.timeZone
            );
            this.queryDate =
              moment
                .tz(
                  this.currentShiftData["currentDate"],
                  "YYYY-MM-DD HH:mm:ss",
                  this.timeZone
                )
                .format("YYYY-MM-DD") || moment.tz(this.timeZone).format("YYYY-MM-DD");
            this.selectedDepartment = this.departmentData[0]["departmentName"];
            this.getAPQOChartData();
            this.getMachineDetails(this.custId);
            this.custDevices(this.custId);
          }
        } else {
          this.departmentData = res["data"];
          var shift: any = {
            shift: this.departmentData[0]["shiftData"],
          };
          sessionStorage.setItem("shiftInfio", JSON.stringify(shift));
          this.currentShiftData = this.currentshifts.getCurrentShift(
            this.departmentData[0]["shiftData"],
            this.timeZone
          );
           this.queryDate =
              moment
                .tz(
                  this.currentShiftData["currentDate"],
                  "YYYY-MM-DD HH:mm:ss",
                  this.timeZone
                )
                .format("YYYY-MM-DD") || moment.tz(this.timeZone).format("YYYY-MM-DD");
          this.selectedDepartment = this.departmentData[0]["departmentName"];
          this.getAPQOChartData();
          this.getMachineDetails(this.custId);
          this.custDevices(this.custId);
        }
      }
    });
  }

  getAPQOChartData() {
    this.dataservice
      .get(
        `department/depthourlyoee?custId=${this.custId}&date=${this.queryDate}&department=${this.selectedDepartment}&shiftName=${this.currentShiftData["usershiftId"]}`
      )
      .subscribe(
        (res) => {
          if (res) {
            this.showload = false;
            this.spinner.hide();
            this.chartData = res;
            this.todaySummary = this.chartData["todaySummary"];
            this.todayData = this.chartData["today"] || [];
            this.yesterdayData = this.chartData["yesterday"] || [];
            this.time = this.chartData["time"] || [];
            this.performanceChart();
            this.oeeChart();
          } else {
            this.showload = false;
            this.spinner.hide();
          }
        },
        (error: any) => {
          this.showload = false;
          this.spinner.hide();
          this.toastr.error(error);
        }
      );
  }
  
  getMachineDetails(custId) {
    var device = {
      custID: custId,
    };
    this.dataservice
      .machineApi(
        "customer_devices",
        device
      )
      .subscribe((res) => {
        this.getData(res, custId);
      });
  }

  custDevices(id) {
    this.dataservice.get(`api/device?custId=${id}`).subscribe((res) => {
      this.deviceList = res;
    });
  }

  performanceChart() {
    this.performanceOption = {
      legend: {
        top: -5,
        icon: "line",
      },
      tooltip: {
        trigger: "axis",
        appendToBody: true,
        backgroundColor: "#fff",
        borderColor: "rgba(82, 78, 78, 0.8)",
        borderWidth: 1,
        textStyle: {
          color: "black", 
          fontSize: 12,
          fontWeight: "bold",
        },
        extraCssText: "border-radius: 8px; padding: 8px;",
        formatter: (params: any) => {
          let tooltipContent = `<div style="text-align: left;">`;
          tooltipContent += `<div style="font-size: 14px; font-weight: bold; margin-bottom: 5px;">🕒 Time: ${params[0]?.axisValue}</div>`;

          let seriesA = params.find(
            (item: any) => item.seriesName === this.yesterdayKey
          );
          let seriesB = params.find(
            (item: any) => item.seriesName === this.todayKey
          );
          params.forEach((item: any) => {
            tooltipContent += `
              <div style="display: flex; align-items: center; margin-bottom: 3px;">
                <div style="width: 10px; height: 10px; background: ${
                  item.color
                }; border-radius: 50%; margin-right: 5px;"></div>
                <div style="font-size: 12px;">
                  <b>${item.seriesName}:</b> ${
              Number(item.value)?.toFixed(2) || "0"
            }%
                </div>
              </div>`;
          });

          if (seriesA && seriesB) {
            let diff = seriesB.value - seriesA.value;
            let diffColor = diff > 0 ? "green" : "red";
            let diffIcon = diff > 0 ? "▲" : "▼";

            tooltipContent += `
              <div style="font-size: 12px; font-weight: bold; color: ${diffColor}; margin-top: 5px; text-align: center;">
                ${diffIcon} ${Math.abs(diff)}%
              </div>`;
          }

          tooltipContent += `</div>`;
          return tooltipContent;
        },
      },

      xAxis: {
        name: "(hrs)",
        type: "category",
        data: this.time,
        axisTick: { show: false },
        axisLabel: {
          rotate: 0,
          fontSize: 9,
          formatter: function (value) {
            return value.split(" - ")[1];
          },
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 100,
        splitNumber: 2,
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          formatter: (value: number) => value + "%",
        },
      },
      grid: {
        left: 50,
        right: "7%",
        top: 10,
        bottom: 100,
      },
      series: [
        {
          name: "Today",
          data: this.todayData?.map((elm: any) => elm.performance.toFixed(2)),
          type: "line",
          symbol: "none",
          smooth: false,
          lineStyle: {
            type: "solid", 
          },
        },
        {
          name: "Yesterday",
          data: this.yesterdayData?.map((elm: any) =>
            elm.performance.toFixed(2)
          ),
          type: "line",
          symbol: "none",
          smooth: false,
          lineStyle: {
            type: "dashed", 
          },
        },
      ],
    };
  }

  oeeChart() {
    this.oeeOption = {
      legend: {
        top: -5,
        icon: "line",
      },
      tooltip: {
        trigger: "axis",
        appendToBody: true,
        backgroundColor: "#fff",
        borderColor: "rgba(82, 78, 78, 0.8)", 
        borderWidth: 1,
        textStyle: {
          color: "black",
          fontSize: 12,
          fontWeight: "bold",
        },
        extraCssText: "border-radius: 8px; padding: 8px;",
        formatter: (params: any) => {
          let tooltipContent = `<div style="text-align: left;">`;
          tooltipContent += `<div style="font-size: 14px; font-weight: bold; margin-bottom: 5px;">🕒 Time: ${params[0]?.axisValue}</div>`;

          let seriesA = params.find(
            (item: any) => item.seriesName === this.yesterdayKey
          );
          let seriesB = params.find(
            (item: any) => item.seriesName === this.todayKey
          );
          params.forEach((item: any) => {
            tooltipContent += `
              <div style="display: flex; align-items: center; margin-bottom: 3px;">
                <div style="width: 10px; height: 10px; background: ${
                  item.color
                }; border-radius: 50%; margin-right: 5px;"></div>
                <div style="font-size: 12px;">
                  <b>${item.seriesName}:</b> ${
              Number(item.value)?.toFixed(2) || "0"
            }%
                </div>
              </div>`;
          });

          if (seriesA && seriesB) {
            let diff = seriesB.value - seriesA.value;
            let diffColor = diff > 0 ? "green" : "red";
            let diffIcon = diff > 0 ? "▲" : "▼";

            tooltipContent += `
              <div style="font-size: 12px; font-weight: bold; color: ${diffColor}; margin-top: 5px; text-align: center;">
                ${diffIcon} ${Math.abs(diff)}%
              </div>`;
          }

          tooltipContent += `</div>`;
          return tooltipContent;
        },
      },

      xAxis: {
        name: "(hrs)",
        type: "category",
        data: this.time,
        axisTick: { show: false },
        axisLabel: {
          rotate: 0,
          fontSize: 9,
          formatter: function (value) {
            return value.split(" - ")[1];
          },
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 100,
        splitNumber: 2,
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          formatter: (value: number) => value + "%",
        },
      },
      grid: {
        left: 50,
        right: "7%",
        top: 10,
        bottom: 100,
      },
      series: [
        {
          name: "Today",
          data: this.todayData?.map((elm: any) => elm.oee.toFixed(2)),
          type: "line",
          symbol: "none",
          smooth: false,
          lineStyle: {
            type: "solid",
          },
        },
        {
          name: "Yesterday",
          data: this.yesterdayData?.map((elm: any) => elm.oee.toFixed(2)),
          type: "line",
          symbol: "none",
          smooth: false,
          lineStyle: {
            type: "dashed",
          },
        },
      ],
    };
  }

  async getData(data, id): Promise<void> {
    this.machine_List = [];

    for (const device of data.devices) {
      if (this.cancelRequest) {
        this.cancelPreviousRequests$.next(); 
        return; 
      }
      try {
        if (this.selectedDepartment == device.departmentName) {
          var datas = {
            custID: id,
            deviceID: device.device_id,
          };
          const response = await this.dataservice
            .machineApi(
              `${ this.liveBool ? "liveMachine" : "machineCard"}`,
              datas
            )
            .pipe(takeUntil(this.cancelPreviousRequests$))
            .toPromise();
        
          this.machine_List.push(response);
          this.machine_List = this.machine_List
            .filter((item) => item !== null)
            .sort((a, b) => {
              const nameA = a.deviceName || "";
              const nameB = b.deviceName || "";
              return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: "base" });
            });
          this.lut = moment
            .tz(this.machine_List?.[0]["LUT"], this.timeZone)
            .format("YYYY-MM-DD HH:mm:ss");
        }
      } catch (error) {
        console.error("Error fetching device data:", error);
      }
    }
  }

  get aiPartCount() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        total =
          this.machine_List?.reduce(
            (sum, item) => sum + (item.Ai_partcount || 0),
            0
          ) || 0;
      } else {
        total = 0;
      }
    // } else {
    //   total = this.todaySummary?.Ai_partcount || 0;
    // }

    return total.toFixed(0);
  }

  get totalEnergy() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        total =
          this.machine_List?.reduce(
            (sum, item) => sum + (item.total_energy || 0),
            0
          ) || 0;
      }
    // } else {
    //   total = this.todaySummary?.total_energy || 0;
    // }
    return total.toFixed(2);
  }

  get energyCost() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        total =
          this.machine_List?.reduce(
            (sum, item) => sum + (item.energy_cost || 0),
            0
          ) || 0;
      }
    // } else {
    //   total = this.todaySummary?.energyCost || 0;
    // }

    return total.toFixed(2);
  }

  get totaloee() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        const sum = this.machine_List.reduce(
          (acc, item) => acc + (item.oee || 0),
          0
        );
        total = sum / this.machine_List.length;
      }
    // } else {
    //   total = this.todaySummary?.avg_oee || 0;
    // }

    return total.toFixed(2);
  }

  get totalperf() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        const sum = this.machine_List.reduce(
          (acc, item) => acc + (item.performance || 0),
          0
        );
        total = sum / this.machine_List.length;
      }
    // } else {
    //   total = this.todaySummary?.avg_perf || 0;
    // }

    return total.toFixed(2);
  }

  get revenueLoss() {
    let total = 0;

    // if (this.liveBool) {
      if (this.machine_List.length) {
        total =
          this.machine_List?.reduce(
            (sum, item) => sum + (item.revenueLoss || 0),
            0
          ) || 0;
      }
    // } else {
    //   total = this.todaySummary?.RevenueLoss || 0;
    // }

    return total.toFixed(2);
  }

  refresh(val: any) {
    this.todayData = [];
    this.yesterdayData = [];
    this.showload = true;
    this.spinner.show();
    if (val == "ts") {
      this.liveBool = false;
    } else {
      this.liveBool = true;
    }
    this.getMachineDetails(this.custId);
    this.custDevices(this.custId);
    this.getAPQOChartData();
  }

  changeDepartment(e) {
    this.cancelPreviousRequests$.next();
    this.selectedDepartment = e.target.value;
    const data = this.departmentData.find(
      (val) => val.departmentName === this.selectedDepartment
    );

    if (data && data.shiftData) {
      var shift: any = {
        shift: data.shiftData,
      };
      sessionStorage.setItem("shiftInfio", JSON.stringify(shift));
      this.currentShiftData = this.currentshifts.getCurrentShift(
        data["shiftData"],
        this.timeZone
      );
    }
    this.refresh("ts");
  }

  epochToHHMMSS(epochTime: any) {
    return moment.tz(epochTime, this.timeZone).format("YYYY-MM-DD HH:mm:ss");
  }

  statusColor(data) {
    switch (data) {
      case 1: {
        return "#548237";
        break;
      }
      case 0: {
        return "#f7c030";
        break;
      }
      case 2: {
        return "#eb5857";
        break;
      }
      case 3: {
        return "#7B542F";
        break;
      }
      case 4: {
        return "#b0b0b0";
        break;
      }
      default: {
        return "#b0b0b0";
        break;
      }
    }
  }

  redirctTO(data, name, type) {
    this.sharedService.setCheckedList({
      custID: this.custId,
      deviceID: data,
      deviceName: name,
      deviceType: type,
    });
    let divdata = this.deviceList.filter((val) => {
      if (val["deviceName"] === name) {
        return val;
      }
    });
    if(divdata[0]["oee"] === 'no_part'){
      var record: any = {
        custID: this.custId,
        deviceID: data,
        deviceName: name,
        deviceType: type,
        department: divdata[0]["departmentName"],
        configType: divdata[0]["oee"],
      };
      sessionStorage.setItem("machineInfio", JSON.stringify(record));
      this.router.navigate(["/detailedMachine"]);
    }else{
      var record: any = {
        custID: this.custId,
        deviceID: data,
        deviceName: name,
        deviceType: type,
        department: divdata[0]["departmentName"],
        configType: divdata[0]["oee"],
        partcountType:divdata[0]["partcountType"]
      };
      sessionStorage.setItem("machineInfio", JSON.stringify(record));
      this.router.navigate(["/detailedMachine"]);
    }
  }

  backbtn() {
    if (this.role === "CUSTOMER") this.router.navigate(["/"]);
  }

  trackByDevice(index: number, item: any): string {
    return item.deviceId;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    if (this.apiInterval) {
      clearInterval(this.apiInterval);
    }
    this.destroy$.next();
    this.destroy$.complete();
    this.cancelRequest = true;
  }

}
